import React, { useEffect, useRef, useState }  from 'react'
import './Header.css'
import { FaPhoneAlt, FaTimes, FaBars } from 'react-icons/fa'
import { FaChevronRight } from 'react-icons/fa6'
import logo from '../../assets/img/logo.svg'
import { Link } from 'react-router-dom'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'


function Header() {

  const logoRef = useRef ()
  const desktopNavRef = useRef(null)
  const headRightRef = useRef(null)

  useGSAP(() => {
    gsap.from(logoRef.current, {
      y: -100,
      delay: 0.5,
      duration: 0.4
    })
  }, { dependencies: [] })

  useGSAP(() => {
    const navItems = desktopNavRef.current?.querySelectorAll('li')

    if (!navItems?.length) {
      return
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const isDesktop = window.matchMedia('(min-width: 992px)').matches

    if (prefersReducedMotion || !isDesktop) {
      gsap.set(navItems, { clearProps: 'all' })
      return
    }

    const tl = gsap.timeline()
    tl.from(navItems, {
      y: -20,
      opacity: 0,
      duration: 0.4,
      ease: 'power3.out',
      stagger: 0.1,
      delay: 0.8
    }).eventCallback('onComplete', () => {
      gsap.set(navItems, { clearProps: 'transform,opacity' })
    })

    return () => tl.kill()
  }, { dependencies: [] })

  useGSAP(() => {
    const buttons = headRightRef.current?.querySelectorAll('button')

    if (!buttons?.length) {
      return
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const isDesktop = window.matchMedia('(min-width: 992px)').matches

    if (prefersReducedMotion || !isDesktop) {
      gsap.set(buttons, { clearProps: 'all' })
      return
    }

    const tl = gsap.timeline()
    tl.from(buttons, {
      y: -20,
      opacity: 0,
      duration: 0.4,
      ease: 'power3.out',
      stagger: 0.15,
      delay: 1.3
    }).eventCallback('onComplete', () => {
      gsap.set(buttons, { clearProps: 'transform,opacity' })
    })

    return () => tl.kill()
  }, { dependencies: [] })
  
  const handleClick =()=>{
    window.scrollTo(0,0);
  }

  const [sticky, setSticky] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  
  useEffect(() => {
    let ticking = false;
    
    const handleScroll = () => {
      // Use requestAnimationFrame to throttle scroll handler and batch layout reads
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollTop = window.scrollY;
          if (scrollTop > 50) { 
            setSticky(true);
          } else {
            setSticky(false);
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const nav = [
    {
      path:'/about', display: 'About Us' 
    },
    {
      path:'/Service', display: 'Services' 
    },
    {
      path:'/product', display: 'Products' 
    },
    {
      path:'/project', display: 'Projects' 
    },
    {
      path:'/clients', display: 'Clients' 
    },
    {
      path:'/contact', display: 'Contact Us' 
    }
  ]

  return (
    <header className={sticky ? 'sticky' : ''}>
      <div className='container flex-between'>
        <div className='logo' ref={logoRef}>
          <Link to='/' onClick={handleClick}><img src={logo} alt='360 Gigabytes Logo' width={130} height={50} /></Link>
        </div>

        <nav className='nav-desktop' ref={desktopNavRef}>
          <ul>
            {nav.map((Header, index) => (
              <li key={index}><Link to={Header.path} onClick={handleClick}>{Header.display}</Link></li>
            ))}
          </ul>
        </nav>

        <button className='mobile-menu-btn' onClick={() => setIsOpen(true)}>
          <FaBars />
        </button>

        <div className='head-rgt' ref={headRightRef}>
        </div>
      </div>

      {isOpen && <div className='overlay' onClick={() => setIsOpen(false)}></div>}

      <div className={`mobile-nav ${isOpen ? 'open' : ''}`}>
        <div className='mobile-nav-header'>
          <span>Menu</span>
          <button onClick={() => setIsOpen(false)}><FaTimes /></button>
        </div>
        <ul>
          {nav.map((Header, index) => (
            <li key={index}>
              <Link to={Header.path} onClick={() => {setIsOpen(false);handleClick();}}>{Header.display}</Link>
            </li>
          ))}
        </ul>
        <div className='head-rgt'>
        </div>
      </div>
    </header>
  );
}

export default Header
